<template>
  <v-ons-page id="landing-page" class="option3 page-column">
    <v-ons-toolbar class="home-toolbar toolbar--cover-content" modifier="transparent" style="border-bottom:none">
      <div class="center"></div>
      <div class="right">
        <v-ons-toolbar-button v-show="showUpdateAlert" @click="checkUpdate()">
          <v-ons-icon icon="fa-bell-o"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="header">
      <div id="logo">

      </div>
    </div>

    <!--<v-ons-list style="margin-top: 20px;">
      <v-ons-list-header>
        Products
      </v-ons-list-header>
    </v-ons-list>-->

    <div class="flex-column background-image" style="-webkit-overflow-scrolling: touch; overflow: scroll;">
      <v-ons-list>
        <v-ons-list-header>
          Products
        </v-ons-list-header>
        <v-ons-list-item
          @click="pushProduct(type)"
          v-for="type in types"
          :key="type.title">
          <div class="center">
            <span>{{ type.title }}</span>
          </div>
          <div class="right">
            <div class="background-cover" :class="type.class"></div>
          </div>
        </v-ons-list-item>
        <v-ons-list-item
          @click="pushCompany()">
          <div class="center tall-item">
            <span>My Favorites</span>
          </div>
          <div class="right">
            <i class="fa fa-star larger-icon"></i>
          </div>
        </v-ons-list-item>
      </v-ons-list>

      <v-ons-list>
        <v-ons-list-header>
          Company Info
        </v-ons-list-header>
        <v-ons-list-item
          v-for="(item, $index) in companyPages"
          @click="pushCompany(item.page, item.filter)"
          :key="$index">
          <div class="center tall-item">
            <span>{{ item.label }}</span>
          </div>
          <div class="right">
            <i class="fa larger-icon" :class="item.icon"></i>
          </div>
        </v-ons-list-item>
      </v-ons-list>
    </div>

  </v-ons-page>
</template>

<script>
import Filters from '../../components/Filters.vue'
import CompanyHistory from '../../components/CompanyHistory.vue'
import Favorites from '../../components/Favorites.vue'
import Legal from '../../components/Legal.vue'
import ContactCards from '../../components/ContactCards.vue'
import { appData } from '../../data.js'

export default {
  name: 'home',
  props: {

  },
  data () {
    return {
      showUpdateAlert: false,
      state: appData.state,
      types: appData.state.types,
      companyPages: [
        {
          label: 'Find a Sales Rep',
          page: ContactCards,
          filter: 'IsSales',
          icon: 'fa-handshake-o'
        },
        {
          label: 'Company History',
          page: CompanyHistory,
          icon: 'fa-university'
        },
        {
          label: 'Company Directory',
          page: ContactCards,
          filter: 'IsCompany',
          icon: 'fa-vcard'
        },
        {
          label: 'Legal',
          page: Legal,
          icon: 'fa-balance-scale'
        }
      ]
    }
  },
  methods: {
    pushProduct(type) {
      this.$emit('push-page', {
        extends: Filters,
        onsNavigatorProps: {
          type: type
        }
      });
    },
    pushCompany(page, filter) {
      page = page ? page : Favorites;
      this.$emit('push-page', {
        extends: page,
        onsNavigatorProps: {
          employees: appData.state.employees.filter(e => e[filter]),
          sales: filter === 'IsSales'
        }
      });
    },
    checkUpdate() {
      this.$ons.notification.confirm('Updates are available. Would you like to get them now?')
        .then(response => {
          if(response == 1) {
            console.log(response);
            this.$emit('refreshContent');
          }
        });
    }
  },
  watch: {
    state: {
      handler: function (val, oldVal) {
        //console.log(val.showUpdateAlert, val.showUpdateAlert);
        this.showUpdateAlert = val.showUpdateAlert;
      },
      deep: true
    }
  },
  computed: {

  },
  created() {

  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 10px;
    flex: none;
  }

  .header img {
    display: block;
    max-width: 300px;
    max-height: 100px;
    height: auto;
    width: auto;
  }

  ons-list-title {
    text-transform: none;
  }

  ons-list-title:not(:first-of-type) {
    margin-top: 30px;
  }

  ons-card {
    text-align: center;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding: 6px;
  }

  ons-card img {
    width: 100%;
  }

  ons-card > * {
    font-size: 20px;
  }

  .list {
    flex: none;
  }

  .background-cover {
    width: 30px;
    height: 30px;
  }

  .larger-icon {
    font-size: 23px;
  }

  .tall-item {
    padding: 17px 6px 17px 0;
  }
</style>



// WEBPACK FOOTER //
// src/Option3/components/Landing.vue